import React from 'react';
import { Phone, HelpCircle, CheckCircle, ArrowRight, FileText, AlertCircle } from 'lucide-react';
export function WhatElseDoINeedToKnowPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-4026">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-4027">
        <div className="container mx-auto px-4" data-id="element-4028">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-4029">
            What Else Do I Need to Know?
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-4030">
            Additional CDL Requirements & Information
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-4031">
        <div className="max-w-4xl mx-auto" data-id="element-4032">
          {/* Do I Need a Chauffeur License? */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4033">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4034">
              <HelpCircle className="mr-3 text-[#B1050B]" size={28} data-id="element-4035" />
              Do I Need a Chauffeur License?
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4036">
              <p className="text-gray-800 mb-4 font-semibold" data-id="element-4037">
                A chauffeur base license is required when a person is:
              </p>
            </div>

            <div className="space-y-4" data-id="element-4038">
              <div className="bg-green-50 rounded-lg p-6" data-id="element-4039">
                <div className="flex items-start" data-id="element-4040">
                  <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4041" />
                  <p className="text-gray-700" data-id="element-4042">
                    <strong data-id="element-4043">Employed for the principal purpose</strong> of
                    operating a motor vehicle or combination of vehicles with a
                    GVWR or GCWR or GVW or GCW of{' '}
                    <strong data-id="element-4044">10,000 pounds or more</strong>
                  </p>
                </div>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-4045">
                <div className="flex items-start" data-id="element-4046">
                  <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4047" />
                  <p className="text-gray-700" data-id="element-4048">
                    Operating a motor vehicle as a{' '}
                    <strong data-id="element-4049">carrier of passengers</strong> or as a{' '}
                    <strong data-id="element-4050">common or contract carrier of property</strong>
                  </p>
                </div>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-4051">
                <div className="flex items-start" data-id="element-4052">
                  <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4053" />
                  <p className="text-gray-700" data-id="element-4054">
                    Operating a{' '}
                    <strong data-id="element-4055">bus, school bus, taxi or limousine</strong>
                  </p>
                </div>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6" data-id="element-4056">
                <div className="flex items-start" data-id="element-4057">
                  <AlertCircle className="text-yellow-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4058" />
                  <div data-id="element-4059">
                    <p className="text-gray-800 mb-2" data-id="element-4060">
                      <strong data-id="element-4061">Important Medical Requirement:</strong>
                    </p>
                    <p className="text-gray-700" data-id="element-4062">
                      Drivers operating vehicles singly or in combination with a
                      GVW, GVWR, GCW or GCWR of{' '}
                      <strong data-id="element-4063">10,000 pounds or more</strong> must meet the{' '}
                      <strong data-id="element-4064">commercial driver medical requirements</strong>{' '}
                      (including possession of the appropriate medical card or
                      medical waiver).
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 rounded-lg p-6" data-id="element-4065">
                <p className="text-gray-700" data-id="element-4066">
                  If required, the{' '}
                  <strong data-id="element-4067">CDL group designator and CDL endorsements</strong> are
                  added to the chauffeur base license.
                </p>
              </div>
            </div>
          </div>

          {/* Converting Out-of-State CDL */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4068">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4069">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-4070" />
              Converting Out-of-State CDL to Michigan CDL
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-4071">
              <p className="text-gray-800" data-id="element-4072">
                When moving to Michigan from another state, you must apply for a
                Michigan CDL to operate commercial vehicles. To obtain a
                Michigan CDL, you must visit a Secretary of State branch office
                and:
              </p>
            </div>

            <div className="space-y-4" data-id="element-4073">
              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4074">
                <div className="flex items-start" data-id="element-4075">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4076">
                    1
                  </div>
                  <div data-id="element-4077">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4078">
                      Surrender Your Out-of-State CDL
                    </p>
                    <p className="text-gray-700 text-sm" data-id="element-4079">
                      You must turn in your current out-of-state CDL
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4080">
                <div className="flex items-start" data-id="element-4081">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4082">
                    2
                  </div>
                  <div data-id="element-4083">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4084">
                      Complete Computer Check
                    </p>
                    <p className="text-gray-700 text-sm mb-3" data-id="element-4085">
                      Eligibility status check through national and state
                      records
                    </p>
                    <div className="bg-red-50 border-l-4 border-red-500 p-4" data-id="element-4086">
                      <p className="text-sm text-gray-800" data-id="element-4087">
                        <strong data-id="element-4088">Important:</strong> If your driving privilege is
                        suspended, revoked, denied or cancelled for any reason
                        in any other state, you{' '}
                        <strong data-id="element-4089">cannot receive your Michigan CDL</strong> until
                        the out-of-state licensing issue(s) are resolved. The
                        driving record check must be completed by the branch
                        office before your CDL can be issued.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4090">
                <div className="flex items-start" data-id="element-4091">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4092">
                    3
                  </div>
                  <div data-id="element-4093">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4094">
                      Pass the Vision Test
                    </p>
                    <p className="text-gray-700 text-sm" data-id="element-4095">
                      Required for all CDL applicants
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4096">
                <div className="flex items-start" data-id="element-4097">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4098">
                    4
                  </div>
                  <div data-id="element-4099">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4100">
                      Take Michigan CDL Written Tests (If Required)
                    </p>
                    <p className="text-gray-700 text-sm mb-3" data-id="element-4101">
                      Required if you are:
                    </p>
                    <ul className="space-y-2 text-sm text-gray-700" data-id="element-4102">
                      <li className="flex items-start" data-id="element-4103">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4104" />
                        <span data-id="element-4105">Upgrading your group designator</span>
                      </li>
                      <li className="flex items-start" data-id="element-4106">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4107" />
                        <span data-id="element-4108">Adding endorsements</span>
                      </li>
                      <li className="flex items-start" data-id="element-4109">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4110" />
                        <span data-id="element-4111">Removing an air brake restriction</span>
                      </li>
                    </ul>
                    <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-4" data-id="element-4112">
                      <p className="text-sm text-gray-800" data-id="element-4113">
                        <strong data-id="element-4114">Note:</strong> To keep your{' '}
                        <strong data-id="element-4115">H-Hazardous Materials endorsement</strong>, you
                        must <strong data-id="element-4116">always</strong> take and pass the Hazmat
                        written test. Otherwise, written tests are not required
                        if you are not upgrading your CDL.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-lg p-6" data-id="element-4117">
                <div className="flex items-start" data-id="element-4118">
                  <div className="bg-[#B1050B] text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4119">
                    5
                  </div>
                  <div data-id="element-4120">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4121">
                      Take Michigan CDL Skills Test (If Required)
                    </p>
                    <p className="text-gray-700 text-sm mb-3" data-id="element-4122">
                      Required if you are:
                    </p>
                    <ul className="space-y-2 text-sm text-gray-700 mb-4" data-id="element-4123">
                      <li className="flex items-start" data-id="element-4124">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4125" />
                        <span data-id="element-4126">Upgrading your group designator</span>
                      </li>
                      <li className="flex items-start" data-id="element-4127">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4128" />
                        <span data-id="element-4129">Adding the P-Passenger endorsement</span>
                      </li>
                      <li className="flex items-start" data-id="element-4130">
                        <ArrowRight className="text-blue-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-4131" />
                        <span data-id="element-4132">
                          Removing a CDL limitation (such as air brake
                          restriction)
                        </span>
                      </li>
                    </ul>
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-4133">
                      <p className="text-sm text-gray-800 mb-2" data-id="element-4134">
                        <strong data-id="element-4135">Important Timing:</strong>
                      </p>
                      <p className="text-sm text-gray-700" data-id="element-4136">
                        If a CDL skills test is required, you must{' '}
                        <strong data-id="element-4137">
                          wait until you receive your photo Michigan base
                          license
                        </strong>{' '}
                        (operator or chauffeur) to take the test. Your Michigan
                        photo driver license must be presented to the third
                        party driver skills test organization before your CDL
                        skills test can be administered. Generally, your regular
                        driver license (operator or chauffeur) will be{' '}
                        <strong data-id="element-4138">mailed to you within ten (10) days</strong>.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white border-2 border-green-500 rounded-lg p-6" data-id="element-4139">
                <div className="flex items-start" data-id="element-4140">
                  <div className="bg-green-600 text-white font-bold px-4 py-2 rounded mr-4 flex-shrink-0" data-id="element-4141">
                    6
                  </div>
                  <div data-id="element-4142">
                    <p className="font-bold text-gray-900 mb-2" data-id="element-4143">
                      Receive Your Michigan CDL
                    </p>
                    <p className="text-gray-700 text-sm" data-id="element-4144">
                      Upon proper and successful completion of any necessary CDL
                      tests and payment of fees
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Incidental Drivers */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-4145">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-4146">
              <HelpCircle className="mr-3 text-[#B1050B]" size={28} data-id="element-4147" />
              Do "Incidental" Drivers Need a CDL?
            </h2>

            <div className="bg-red-50 border-2 border-red-500 rounded-lg p-6" data-id="element-4148">
              <div className="flex items-start" data-id="element-4149">
                <AlertCircle className="text-red-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-4150" />
                <div data-id="element-4151">
                  <p className="text-gray-800 font-semibold mb-3" data-id="element-4152">
                    Unless exempt, any driver who operates a commercial motor
                    vehicle on roads or highways that are accessible to the
                    public, <strong data-id="element-4153">must have a CDL</strong> regardless of:
                  </p>
                  <ul className="space-y-2 text-gray-700" data-id="element-4154">
                    <li className="flex items-start" data-id="element-4155">
                      <span className="text-red-600 mr-2" data-id="element-4156">•</span>
                      <span data-id="element-4157">The distance driven</span>
                    </li>
                    <li className="flex items-start" data-id="element-4158">
                      <span className="text-red-600 mr-2" data-id="element-4159">•</span>
                      <span data-id="element-4160">Amount of driving time</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 rounded-lg p-6 mt-6" data-id="element-4161">
              <p className="text-gray-700" data-id="element-4162">
                <strong data-id="element-4163">Bottom line:</strong> If you operate a CMV on public
                roads or highways, you need a CDL - even if it's only
                occasionally or for short distances.
              </p>
            </div>
          </div>

          {/* Quick Reference Summary */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-4164">
            <h2 className="text-3xl font-bold mb-6" data-id="element-4165">Quick Reference</h2>

            <div className="space-y-6" data-id="element-4166">
              <div data-id="element-4167">
                <h3 className="text-xl font-bold mb-3" data-id="element-4168">
                  Chauffeur License Required For:
                </h3>
                <ul className="space-y-2 text-sm" data-id="element-4169">
                  <li data-id="element-4170">• Employed to operate vehicles ≥10,000 lbs</li>
                  <li data-id="element-4171">• Carrier of passengers or property</li>
                  <li data-id="element-4172">• Bus, school bus, taxi, or limousine</li>
                  <li data-id="element-4173">• Medical card required for 10,000+ lbs vehicles</li>
                </ul>
              </div>

              <div data-id="element-4174">
                <h3 className="text-xl font-bold mb-3" data-id="element-4175">
                  Out-of-State CDL Conversion (6 Steps):
                </h3>
                <ul className="space-y-2 text-sm" data-id="element-4176">
                  <li data-id="element-4177">1. Surrender out-of-state CDL</li>
                  <li data-id="element-4178">2. Complete computer eligibility check</li>
                  <li data-id="element-4179">3. Pass vision test</li>
                  <li data-id="element-4180">
                    4. Take written tests (if upgrading/adding endorsements)
                  </li>
                  <li data-id="element-4181">
                    5. Take skills test (if upgrading/adding P endorsement)
                  </li>
                  <li data-id="element-4182">6. Receive Michigan CDL upon completion</li>
                </ul>
              </div>

              <div data-id="element-4183">
                <h3 className="text-xl font-bold mb-3" data-id="element-4184">Incidental Drivers:</h3>
                <p className="text-sm" data-id="element-4185">
                  CDL required for ANY CMV operation on public roads -
                  regardless of distance or time
                </p>
              </div>
            </div>
          </div>

          {/* Key Takeaways */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-4186">
            <h2 className="text-3xl font-bold mb-6" data-id="element-4187">Key Takeaways</h2>

            <div className="space-y-3" data-id="element-4188">
              <div className="flex items-start" data-id="element-4189">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4190" />
                <span data-id="element-4191">
                  Chauffeur license required for vehicles ≥10,000 lbs, passenger
                  carriers, buses, taxis, limos
                </span>
              </div>
              <div className="flex items-start" data-id="element-4192">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4193" />
                <span data-id="element-4194">Medical card required for 10,000+ lbs vehicles</span>
              </div>
              <div className="flex items-start" data-id="element-4195">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4196" />
                <span data-id="element-4197">
                  Out-of-state CDL must be surrendered when converting to
                  Michigan
                </span>
              </div>
              <div className="flex items-start" data-id="element-4198">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4199" />
                <span data-id="element-4200">
                  Cannot receive Michigan CDL if suspended/revoked in another
                  state
                </span>
              </div>
              <div className="flex items-start" data-id="element-4201">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4202" />
                <span data-id="element-4203">Hazmat endorsement always requires written test</span>
              </div>
              <div className="flex items-start" data-id="element-4204">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4205" />
                <span data-id="element-4206">
                  Skills test requires waiting for photo Michigan base license
                  (10 days)
                </span>
              </div>
              <div className="flex items-start" data-id="element-4207">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-4208" />
                <span data-id="element-4209">
                  Incidental drivers need CDL regardless of distance or time
                </span>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-4210">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4211">
              Have More Questions About CDL Requirements?
            </h2>
            <p className="text-xl mb-6" data-id="element-4212">
              Expert guidance on chauffeur licenses, CDL conversion, and
              compliance
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-4213">
              <Phone className="mr-3" size={24} data-id="element-4214" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-4215">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}